export { default } from '@/components/Memory/MemoryPage';
